import React from 'react';
import { ThemeProp } from 'types/index';

const ThemeContext = React.createContext<ThemeProp>('dark');
export default ThemeContext;
